import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Show banner after a short delay
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({
        necessary: true,
        analytics: true,
        marketing: true,
        timestamp: new Date().toISOString(),
      })
    );
    setIsVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({
        necessary: true,
        analytics: false,
        marketing: false,
        timestamp: new Date().toISOString(),
      })
    );
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 cookie-banner"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-2xl border border-brand-border p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-heading text-lg font-semibold text-brand-foreground mb-2">
              🍪 Utilizziamo i Cookie
            </h3>
            <p className="text-brand-muted text-sm leading-relaxed mb-4">
              Questo sito utilizza cookie tecnici necessari al funzionamento e cookie 
              analitici per migliorare la tua esperienza. Puoi accettare tutti i cookie 
              o solo quelli necessari. Per maggiori informazioni consulta la nostra{" "}
              <Link
                to="/cookie-policy"
                className="text-brand-primary hover:underline font-medium"
                data-testid="cookie-banner-policy-link"
              >
                Cookie Policy
              </Link>
              .
            </p>
            <div className="flex flex-wrap gap-3">
              <Button
                onClick={acceptAll}
                className="bg-brand-primary hover:bg-brand-primary-dark text-white rounded-full px-6"
                data-testid="cookie-accept-all-btn"
              >
                Accetta Tutti
              </Button>
              <Button
                onClick={acceptNecessary}
                variant="outline"
                className="border-brand-primary text-brand-primary hover:bg-brand-secondary rounded-full px-6"
                data-testid="cookie-accept-necessary-btn"
              >
                Solo Necessari
              </Button>
            </div>
          </div>
          <button
            onClick={acceptNecessary}
            className="p-2 text-brand-muted hover:text-brand-foreground transition-colors"
            data-testid="cookie-close-btn"
            aria-label="Chiudi"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
